import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { selectors } from '../Stream';
import { StreamType } from '../Stream/types';
import { getFetchActionForStreamType } from '../Stream/helpers';
var mapStateToProps = function (state, _a) {
    var streamId = _a.streamId;
    return ({
        hasMore: selectors.hasMore(state, streamId),
        isFetching: selectors.isFetching(state, streamId),
        hasError: !!selectors.getErrorMsg(state, streamId),
        isEmpty: (selectors.getItems(state, streamId) || []).length === 0,
    });
};
var mapDispatchToProps = function (dispatch, _a) {
    var _b = _a.streamType, streamType = _b === void 0 ? StreamType.WITH_OFFSET : _b;
    return bindActionCreators({
        fetchMore: getFetchActionForStreamType(streamType),
    }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=StreamedList.container.js.map